import { jsx as e, jsxs as c, Fragment as f } from "react/jsx-runtime";
import { c as h } from "../index-DpeO8ABv.js";
import { c as a } from "../clsx-OuTLNxxd.js";
import { forwardRef as y } from "react";
import { B as m } from "../Button-BDQYwrrG.js";
import "../SocialButton.css?__remix_sideEffect__";const r = "320px",u = "600px",H = "1025px",p = "_isVisuallyHidden_bfnjr_52",b = "_facebookButton_bfnjr_64",B = "_googleButton_bfnjr_65",x = {
    mobile: r,
    "mobile-wide": "480px",
    tablet: u,
    "tablet-wide": "800px",
    desktop: H,
    "desktop-mid": "1281px",
    "desktop-large": "1360px",
    "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
    "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
    "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
    "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
    "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
    "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
    "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
    "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
    "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
    "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
    "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
    "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
    "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
    "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
    "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
    isVisuallyHidden: p,
    facebookButton: b,
    googleButton: B
  };
function C(t) {
  const o = t.replace(/([A-Z])/g, " $1");
  return o.charAt(0).toUpperCase() + o.slice(1);
}
const S = h(x.button, {
    variants: {
      variant: {
        facebook: x.facebookButton,
        google: x.googleButton
      }
    }
  }),j = y(
    ({
      children: t,
      className: o,
      variant: i,
      disabled: l,
      isLoading: n,
      asChild: v = !1,
      ...g
    }, d) => {
      const s = () => i ? /* @__PURE__ */e(z, { variant: i, isLoading: n }) : t;
      return /* @__PURE__ */e(
        m,
        {
          className: a(S({ variant: i }), o),
          disabled: l,
          ref: d,
          "data-testid": "button-component",
          isLoading: n,
          loadingText: n ? /* @__PURE__ */e(s, {}) : "",
          ...g,
          children: /* @__PURE__ */e(s, {})
        }
      );
    }
  ),z = ({
    variant: t,
    isLoading: o
  }) => {
    const i = {
        facebook: /* @__PURE__ */e(W, {}),
        google: /* @__PURE__ */e(w, {})
      },l = () => i[t],n = C(t);
    return /* @__PURE__ */c(f, { children: [
      /* @__PURE__ */e(l, {}),
      /* @__PURE__ */c("span", { children: [
        o ? "Loading" : `Sign in with ${n}`,
        " "]
      })]
    });
  };
function W(t) {
  return /* @__PURE__ */e(
    "svg",
    {
      ...t,
      fill: "none",
      height: "20",
      viewBox: "0 0 22 20",
      width: "22",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */e(
        "path",
        {
          d: "M21.7838 10.1215C21.7838 4.59863 17.0949 0.121481 11.3109 0.121481C5.5268 0.121481 0.837891 4.59863 0.837891 10.1215C0.837891 15.1128 4.66771 19.2498 9.67446 20V13.0121H7.01531V10.1215H9.67446V7.91836C9.67446 5.41211 11.238 4.02773 13.6303 4.02773C14.7761 4.02773 15.9746 4.22304 15.9746 4.22304V6.68398H14.654C13.353 6.68398 12.9473 7.45482 12.9473 8.24564V10.1215H15.8519L15.3875 13.0121H12.9473V20C17.954 19.2498 21.7838 15.1128 21.7838 10.1215Z",
          fill: "white"
        }
      )
    }
  );
}
function w(t) {
  return /* @__PURE__ */c(
    "svg",
    {
      ...t,
      fill: "none",
      height: "20",
      viewBox: "0 0 22 20",
      width: "22",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
      /* @__PURE__ */e(
        "path",
        {
          clipRule: "evenodd",
          d: "M20.9793 10.2273C20.9793 9.51825 20.9127 8.83643 20.7889 8.18188H10.9253V12.0501H16.5617C16.3189 13.3001 15.581 14.3592 14.4718 15.0682V17.5773H17.8565C19.8368 15.8364 20.9793 13.2728 20.9793 10.2273Z",
          fill: "#4285F4",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */e(
        "path",
        {
          clipRule: "evenodd",
          d: "M10.9254 19.9999C13.7531 19.9999 16.1238 19.1044 17.8566 17.5772L14.472 15.0681C13.5342 15.6681 12.3345 16.0226 10.9254 16.0226C8.1977 16.0226 5.88889 14.2635 5.06533 11.8999H1.56641V14.4908C3.28969 17.759 6.83146 19.9999 10.9254 19.9999Z",
          fill: "#34A853",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */e(
        "path",
        {
          clipRule: "evenodd",
          d: "M5.06551 11.8999C4.85605 11.2999 4.73703 10.659 4.73703 9.99994C4.73703 9.34085 4.85605 8.69994 5.06551 8.09994V5.50903H1.56658C0.857274 6.85903 0.452637 8.38631 0.452637 9.99994C0.452637 11.6136 0.857274 13.1409 1.56658 14.4909L5.06551 11.8999Z",
          fill: "#FBBC05",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */e(
        "path",
        {
          clipRule: "evenodd",
          d: "M10.9254 3.97727C12.4631 3.97727 13.8436 4.48182 14.929 5.47273L17.9328 2.60455C16.1191 0.990909 13.7484 0 10.9254 0C6.83146 0 3.28969 2.24091 1.56641 5.50909L5.06533 8.1C5.88889 5.73636 8.1977 3.97727 10.9254 3.97727Z",
          fill: "#EA4335",
          fillRule: "evenodd"
        }
      )]

    }
  );
}
export {
  j as SocialButton,
  S as socialButtonVariants };